import { render, staticRenderFns } from "./void.vue?vue&type=template&id=47c5fb1e&scoped=true&"
import script from "./void.vue?vue&type=script&lang=js&"
export * from "./void.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c5fb1e",
  null
  
)

export default component.exports